import { j as a } from "../../../../node_modules/react/jsx-runtime.js";
import { memo as c } from "react";
import m from "../Calender.module.scss.js";
import { clsx as p } from "../../../../node_modules/clsx/dist/clsx.m.js";
import d from "../../ScrollbarContainer/ScrollBarContainer.js";
import { isYearDisabled as i } from "../calender.helper.js";
import { getYear as n } from "../../../../node_modules/date-fns/getYear.js";
const f = n(/* @__PURE__ */ new Date()), u = Array.from({ length: 200 }, (o, t) => f - 100 + t), b = ({ onChange: o, currentMonth: t, minDate: s, maxDate: e }) => /* @__PURE__ */ a.jsx(d, { className: m.years, children: u.map((r, l) => /* @__PURE__ */ a.jsx(
  "button",
  {
    className: p({
      [m.active]: r === n(t),
      "!cursor-not-allowed opacity-disabled": i(r, s, e)
    }),
    onClick: () => o(new Date(r, 0, 1)),
    type: "button",
    "data-testid": r,
    disabled: i(r, s, e),
    children: r
  },
  l
)) }), N = c(b);
export {
  N as default
};
//# sourceMappingURL=Years.js.map
